// @ts-check
// Atalho "Criar modelo" (contrato 08 de leads e WhatsApp, seção 7): leva à tela de modelos já no formulário de
// criação. Só aparece para quem pode criar (flag WORKSPACE); os demais leem quem cria os modelos. Com algo digitado
// na tela de origem (destinatário, texto, anexo ou modelo), o link abre em nova aba para o rascunho não se perder;
// Ctrl/Cmd e o clique do meio são nativos. O endereço leva a tela de origem para o "Voltar para onde você estava".
import { html } from 'htm/preact';
import { locationState, navigate } from '../../../app/router.js';
import { hasCurrentPermissionFlag } from '../../../data/metadata-store.js';
import { Icon } from '../../../ui/icon.js';
import { buildCreateTemplateHref } from '../../../lib/whatsapp-templates.js';
import { t } from '../../../i18n/index.js';

/** @param {MouseEvent} event */
const isPlainClick = (event) => event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;

/**
 * @param {{ channelId?: string | null, hasDraft?: boolean, onBeforeNavigate?: () => void, prefix?: string, memberText?: string, className?: string }} props
 */
export function CreateTemplateShortcut({ channelId = null, hasDraft = false, onBeforeNavigate, prefix, memberText, className = '' }) {
  if (!hasCurrentPermissionFlag('WORKSPACE')) {
    return html`<p class=${`template-shortcut template-shortcut-note ${className}`}><${Icon} name="IconInfoCircle" size=${14} /><span>${memberText ?? t('whatsappTemplates.shortcut.memberNote')}</span></p>`;
  }
  const href = buildCreateTemplateHref(channelId, `${locationState.value.pathname}${locationState.value.search}`);
  return html`<p class=${`template-shortcut ${className}`}>
    ${prefix ? html`<span>${prefix}</span>` : null}
    <a class="integration-link template-shortcut-link" href=${href} target=${hasDraft ? '_blank' : undefined} rel=${hasDraft ? 'noopener' : undefined}
      onClick=${(/** @type {MouseEvent} */ event) => {
        if (hasDraft || !isPlainClick(event)) return;
        event.preventDefault();
        onBeforeNavigate?.();
        navigate(href);
      }}>
      <${Icon} name="IconPlus" size=${14} />${t('whatsappTemplates.shortcut.create')}${hasDraft ? html`<span class="visually-hidden-text"> (${t('whatsappTemplates.shortcut.opensInNewTab')})</span>` : null}
    </a>
  </p>`;
}
